var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "__pop-nutritional",
          attrs: {
            title: "代客下单",
            width: "950px",
            top: "10vh",
            center: true,
            visible: _vm.isShow,
            "append-to-body": true,
          },
          on: {
            close: _vm.closePop,
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "代客下单表单",
              staticClass: "form-box",
              attrs: {
                inline: true,
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "phone", label: "下单手机号：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              placeholder: "请输入手机号",
                              maxlength: "11",
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "phone", $$v)
                              },
                              expression: "formData.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "productId", label: "选择商品：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: { filterable: "", placeholder: "请选择" },
                              on: { change: _vm.changeProduct },
                              model: {
                                value: _vm.formData.productId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "productId", $$v)
                                },
                                expression: "formData.productId",
                              },
                            },
                            _vm._l(_vm.productList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.storeName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "specId", label: "选择规格：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: { filterable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.formData.specId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "specId", $$v)
                                },
                                expression: "formData.specId",
                              },
                            },
                            _vm._l(_vm.specList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.suk, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "productNum", label: "下单数量：" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              precision: 0,
                              step: 1,
                              min: 1,
                              max: 99999999,
                            },
                            model: {
                              value: _vm.formData.productNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "productNum", $$v)
                              },
                              expression: "formData.productNum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { border: "1px solid #f2f2f2" } },
                [
                  _c("div", { staticClass: "address-box" }, [
                    _vm._v("收货信息："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "userAddressRealName",
                            label: "姓名：",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              placeholder: "请输入姓名",
                              maxlength: "10",
                            },
                            model: {
                              value: _vm.formData.userAddressRealName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "userAddressRealName",
                                  $$v
                                )
                              },
                              expression: "formData.userAddressRealName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "userAddressPhone",
                            label: "收货手机号：",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              placeholder: "请输入收货手机号",
                              maxlength: "11",
                            },
                            model: {
                              value: _vm.formData.userAddressPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "userAddressPhone", $$v)
                              },
                              expression: "formData.userAddressPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "cityIdList", label: "收货地址：" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              props: _vm.addressProps,
                              options: _vm.cityList,
                              clearable: "",
                            },
                            on: { change: _vm.changeAddress },
                            model: {
                              value: _vm.formData.cityIdList,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cityIdList", $$v)
                              },
                              expression: "formData.cityIdList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "userAddressDetail",
                            label: "详细地址：",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              placeholder: "请输入详细地址",
                              "show-word-limit": "",
                              clearable: "",
                              maxlength: "20",
                            },
                            model: {
                              value: _vm.formData.userAddressDetail,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "userAddressDetail", $$v)
                              },
                              expression: "formData.userAddressDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "24px" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "realPrice", label: "实收价：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "170px" },
                            attrs: {
                              placeholder: "请输入实收价",
                              maxlength: "10",
                            },
                            model: {
                              value: _vm.formData.realPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "realPrice", $$v)
                              },
                              expression: "formData.realPrice",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "tip-box" }, [
                            _vm._v("应收价为："),
                            _c("span", { staticClass: "price-box" }, [
                              _vm._v(_vm._s(_vm.payPrice)),
                            ]),
                            _vm._v(" 元"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "payType", label: "收货方式：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: { placeholder: "请选择收货方式" },
                              model: {
                                value: _vm.formData.payType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "payType", $$v)
                                },
                                expression: "formData.payType",
                              },
                            },
                            _vm._l(_vm.payTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-item cancel-btn",
                  on: { click: _vm.closePop },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }